import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { styled } from '@material-ui/core';
import React, { Children, isValidElement, ReactNode } from 'react';
import BubbleButton from './BubbleButton';
import BubbleContent from './BubbleContent';
import BubbleStepper from './BubbleStepper';
import BubbleTitle from './BubbleTitle';

interface Props {
  error?: boolean;
  children?: ReactNode;
}

const TitleType = (<BubbleTitle />).type;
const StepperType = (<BubbleStepper />).type;
const ContentType = (<BubbleContent />).type;
const ButtonType = (<BubbleButton />).type;

const getChildren = (children: ReactNode, type: any) => {
  return Children.toArray(children).filter(
    (v) => isValidElement(v) && type === v.type
  );
};

const getExtendedChildren = (
  children: ReactNode,
  props: Omit<Props, 'children'>
) => {
  return Children.map(children, (child) => {
    return (
      isValidElement(child) &&
      React.cloneElement(child, {
        ...props
      })
    );
  });
};

export default function BubbleMain({ children, error }: Props) {
  const extendedChildren = getExtendedChildren(children, { error });
  const title = getChildren(extendedChildren, TitleType);
  const stepper = getChildren(extendedChildren, StepperType);
  const content = getChildren(extendedChildren, ContentType);
  const button = getChildren(extendedChildren, ButtonType);

  return (
    <Wrapper>
      <Header error={error}>
        <CustomizedTypography variant="body2" fontWeight="700" color="inherit">
          진행알림
        </CustomizedTypography>
      </Header>
      {title}
      {stepper}
      {content}
      {button}
    </Wrapper>
  );
}

const Wrapper = styled('div')({
  width: 230,
  borderRadius: 10,
  backgroundColor: colorSet.gray000,
  paddingBottom: 16
});

const Header = styled('div')(({ error }: Props) => ({
  borderRadius: '10px 10px 0px 0px',
  padding: '10px 16px',
  color: colorSet.gray000,
  backgroundColor: error ? colorSet.errorMain : colorSet.primary500
}));
